import i18n from 'modules/core/lib/i18n'

import { Status } from 'modules/surveys/store/models/v2/Survey'

export const tagColor = (surveyStatus: string) => {
  switch (surveyStatus) {
    case Status.draft:
      return 'champagne'
    case Status.scheduled:
      return 'purple'
    case Status.active:
      return 'lime'
    default:
      return 'grey'
  }
}

export const tagLabel = (surveyStatus: string) => {
  switch (surveyStatus) {
    case Status.draft:
      return i18n.t('surveys.index.table.filters.draft')
    case Status.scheduled:
      return i18n.t('surveys.index.table.filters.scheduled')
    case Status.active:
      return i18n.t('surveys.index.table.filters.active')
    case Status.finished:
      return i18n.t('surveys.index.table.filters.closed')
    default:
      return i18n.t('surveys.index.table.filters.unknown')
  }
}
